module.exports = __webpack_public_path__ + "img/item-b1.3409f76d.png";